<template>
  <BaseCard
    :heading="t('register.salonized_pay.terminal_settings.language.heading')"
    :description="t('register.salonized_pay.terminal_settings.language.description')"
  >
    <Flex
      direction="column"
      align="start"
    >
      <BaseDropdown
        v-model="language"
        :label="t('register.salonized_pay.terminal_settings.language.label')"
        :options="languageOptions"
        v-test="'sp-terminal-settings-language'"
      />
      <BaseAlert
        color="info"
        :text="t('register.salonized_pay.terminal_settings.applies_to_all')"
      />
    </Flex>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import config from '@/config';
import { capitalize } from '@/helpers/formatting';
import { hasIntlDisplayNames } from '@/helpers/intl';

const { t } = useI18n();

const language = defineModel<string>({ required: true });

const languageOptions = computed(() =>
  config.locales.map((locale) => ({
    value: locale,
    label: hasIntlDisplayNames()
      ? capitalize(
          new Intl.DisplayNames([locale], { type: 'language' }).of(locale) ||
            locale,
        )
      : t(`global.languages.${locale}`),
  })),
);
</script>
